import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'Proyectos';

export interface Proyecto {
	idProyecto: number;
	proyecto: string;
	sociedades: any;
	esIngenieria: boolean;
	fechaBaja: string;
	// onShore: number;
	// offShore: number;
}

export class ProyectosAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarProyectos(): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarProyectos`);
	}

	ListarProyectosSociedad(idSociedad: number): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarProyectos/${idSociedad}`);
	}
	
	CrearProyecto(proyecto: any): AxiosPromise<any[]> {
		return this.cliente.post(proyecto, `/CrearProyecto`);
	}
	
	EliminarProyecto(id: number): AxiosPromise<any> {
		return this.cliente.remove(id, `/EliminarProyecto`);
	}

	ModificarProyecto(proyecto: any): AxiosPromise<any[]> {
		return this.cliente.put(proyecto.idProyecto, proyecto, `/ModificarProyecto`);
	}

	DetalleProyecto(idProyecto: number): AxiosPromise<any[]> {
		return this.cliente.get(`/ DetalleProyecto/${idProyecto}`);
	}

	ListarProyectosCRM(codOferta:string):AxiosPromise<any[]> {
		return this.cliente.get(`/ListarProyectosCRM/${codOferta}`);
	}
}